
export const validate = (value, rules, tillFirstError = false) =>
{
  const errors = [];
  if (!rules || !rules.length)
  {
    return errors;
  }
  for (const rule of rules)
  {
    if (!rule.run(value))
    {
      if (tillFirstError)
      {
        break;
      }
      const result = { name: rule.name, message: rule.message };
      errors.push(result);
    }
  }
  return errors;
}

const EMAIL_REG_EXP =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const PHONE_REG_EXP =
  /^\+?[\d\s\-()]{7,15}$/;

const PASSWORD_REG_EXP =
  /^(?=.*[A-Za-z])(?=.*\d).{6,}$/;

export const validationRuleFactory =
{
  required: (message) =>
    ({
    name: 'required',
    message,
    run: x => x?.length > 0 ? `${x}`.trim().length !== 0 : false,
  }),

  pattern: (regex, message) => ({
    name: 'pattern',
    message,
    run: x => {
      if (!x) return false;
      return regex.test(`${x}`.trim());
    },
  }),
  emailValidation: (message) =>
  ({
    name: "email",
    message,
    run: (x) => !x ? true : EMAIL_REG_EXP.test(x),
  }),
  phoneValidation: (message) =>
  ({
    name: "phone",
    message,
    run: (x) => !x ? true : PHONE_REG_EXP.test(x),
  }),
  passwordValidation: (message) =>
  ({
    name: "password",
    message,
    run: (x) => !x ? true : PASSWORD_REG_EXP.test(x),
  }),
};